import React from 'react';

interface SectionTitleProps {
  children: React.ReactNode;
  className?: string;
  centered?: boolean;
}

export function SectionTitle({ children, className = '', centered = false }: SectionTitleProps) {
  return (
    <h2 className={`text-4xl font-playfair ${centered ? 'text-center' : ''} ${className}`}>
      {children}
    </h2>
  );
}